"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.addManualBankAccountReportArtifacts = exports.createManualBankAccountReport = void 0;
const lodash_1 = require("lodash");
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const createManualBankAccountReport = (cashBalanceFeed) => {
    (0, common_1.finleyAssert)(cashBalanceFeed.creditFacilitySlug, 'creditFacilitySlug of cashBalanceFeed type must be defined');
    return {
        id: (0, uuid_1.v4)(),
        type: 'manualBankAccountReport',
        configuration: {},
        loanProductSlug: null,
        creditFacilitySlug: cashBalanceFeed.creditFacilitySlug,
        artifactDocumentId: cashBalanceFeed.artifactDocumentId,
        externalFilename: null,
        artifactSlug: `manualBankAccountReport_${cashBalanceFeed.creditFacilitySlug}`, // uniq for cashBalanceFeed
    };
};
exports.createManualBankAccountReport = createManualBankAccountReport;
const addManualBankAccountReportArtifacts = (graph) => {
    const dataTapeDependencies = (0, lodash_1.cloneDeep)(graph.dataTapeDependencies);
    const dataTapes = (0, lodash_1.cloneDeep)(graph.dataTapes);
    const generatedCashBalanceFeeds = utils.filterGeneratedCashBalanceFeeds({
        dataTapes,
    });
    const borrowingBaseReports = utils.filterBorrowingBaseReports({ dataTapes });
    const directInsertBorrowingBaseReports = utils.filterDirectInsertBorrowingBaseReports({ dataTapes });
    const borrowingBaseReportIds = [];
    borrowingBaseReports.forEach(({ id }) => borrowingBaseReportIds.push(id));
    directInsertBorrowingBaseReports.forEach(({ id }) => borrowingBaseReportIds.push(id));
    generatedCashBalanceFeeds.forEach((cashBalanceFeed) => {
        const manualBankAccountReport = (0, exports.createManualBankAccountReport)(cashBalanceFeed);
        // remove edge from GeneratedCashBalanceFeed => BorrowingBaseReport
        const removedDependencies = (0, lodash_1.remove)(dataTapeDependencies, (dep) => borrowingBaseReportIds.includes(dep.outputArtifactId) &&
            dep.inputArtifactId === cashBalanceFeed.id);
        // we only need to establish single cashBalanceFeed => manual Bank Account report
        dataTapeDependencies.push({
            inputArtifactId: cashBalanceFeed.id,
            outputArtifactId: manualBankAccountReport.id,
        });
        // re-establish manual bank account report => borrowing base report links
        removedDependencies.forEach((dep) => {
            const { outputDependency } = utils.insertDependency({
                dataTapeDependency: dep,
                insertId: manualBankAccountReport.id,
            });
            dataTapeDependencies.push(outputDependency);
        });
        dataTapes.push(manualBankAccountReport);
    });
    return { dataTapeDependencies, dataTapes };
};
exports.addManualBankAccountReportArtifacts = addManualBankAccountReportArtifacts;
//# sourceMappingURL=manualBankAccountReport.js.map